import $ from 'jquery';
import JourneyTracking from './components/JourneyTracking';
import SectorModal from './components/SectorModal';

$(document).on('ready', function () {
	var navigationMobile = $('.navigation-mobile');
	var navigationMain = $('.navigation-main');
	var energyModal = $('#energy-modal');
	var languageToggle = $('#language-nav-toggle');
	var languageSubmenu = $('.suntrax-language-navigation');
	var languageBkg = $('.language-mobile-menu-background');
	var pressModal = $('#presskit-modal');
	var sectorsModal = $('#sectors-modal');
	var menuButton = $('.menu-button');
	var navWithChildren = $('.navigation-mobile .menu-item-has-children');
	var subMenu = $('.sub-menu');
	var searchModal = $('#search-modal');
	var sectorModal = $('#sector-modal');
	var searches = $('#searches');
	var suggestions = $('#search-suggestions');
	var searchForm = $('.search-form');
	var searchFormButton = $('.search-form button');
	var searchInput = $('.search-form input');
	var pageTitle = $('.page-title.main');
	var pageTitleSticky = $('.page-title--sticky');
	var elementTop = pageTitle.length ? pageTitle.offset().top : null;

	new JourneyTracking();
	new SectorModal();

	/** Opens mobile menu on click */
	$('.menu-button').on('click', function () {
		navigationMobile.removeClass('sub-active');
		$(this).toggleClass('active');
		navigationMobile.toggleClass('active');
		navigationMain.toggleClass('active');
		subMenu.removeClass('active');

		if(languageSubmenu.hasClass('visible')){
			languageSubmenu.toggleClass('visible');
			languageBkg.toggleClass('visible');
		}
	});

	/** Toggles sub menu on click */
	navWithChildren.on('click', function () {
		if (!$(this).children('.sub-menu').hasClass('active')) {
			$(this).children('.sub-menu').addClass('active');
			navigationMobile.addClass('sub-active');
		} else {
			$(this).children('.sub-menu').removeClass('active');
			navigationMobile.removeClass('sub-active');
		}

		let text = $(this).children('a').text();

		if (!$(this).children('.sub-menu').children('li:first').hasClass('return-link')) {
			$(this).children('.sub-menu').prepend(`<li class='return-link menu-item'>${text}</li>`);
			$(this).children('.sub-menu').append(`<a href="/get-started" class="nav-cta_button"> Get Started </a>`);
		}
	});

	/** Opens Energy menu modal */
	$('.energy-modal-toggle').on('click', function () {
		energyModal.toggleClass('is-visible');
	});

	/** Opens Search menu modal */
	$('.search-modal-toggle').on('click', function () {
		searchModal.toggleClass('is-visible');
		if (!$('html').hasClass("no-scroll")) {
			$('html').addClass('no-scroll');
			document.getElementById("s").focus();
		} else {
			$('html').removeClass('no-scroll');
		}
	});

	/** Opens Sector menu modal */
	$('.sector-modal-toggle').on('click', function () {
		sectorModal.toggleClass('is-visible');
	});

	/** Opens Presskit menu modal */
	$('.presskit-modal-toggle').on('click', function () {
		pressModal.toggleClass('is-visible');
	});

	/** Opens Presskit menu modal */
	$('.sectors-modal-toggle').on('click', function () {
		sectorsModal.toggleClass('is-visible');
	});

	/** Check if Search Field has value  */
	searchInput.on('input', function () {
		if ($(this).val()) {
			searchForm.addClass('has-value');
			searchFormButton.addClass('clear');
			//suggestions.addClass('active');
			//searches.addClass('inactive');
		} else {
			searchForm.removeClass('has-value');
			searchFormButton.removeClass('clear');
			//suggestions.removeClass('active');
			//searches.removeClass('inactive');
		}
	});

	/** Page title sticky scroll */
	$(window).on('scroll', function () {
		var elementBottom = elementTop + pageTitle.outerHeight() + 150;
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		var isVisible = elementBottom > viewportTop && elementTop < viewportBottom;

		if (pageTitleSticky) {
			if (!isVisible) {
				pageTitleSticky.addClass('visible');
			} else {
				pageTitleSticky.removeClass('visible');
			}
		}
	});

	/** Clear search input on toggle*/
	searchFormButton.on('click', function () {
		if ($(this).hasClass('clear')) {
			searchInput.val('');
			searchForm.removeClass('has-value');
			//suggestions.removeClass('active');
			//searches.removeClass('inactive');
			searchFormButton.removeClass('clear');
		}
	});

	/** Language translation toggle**/
	$('#language-nav-toggle, .language-mobile-menu-background').on('click', function() {
		languageSubmenu.toggleClass('visible');
		languageBkg.toggleClass('visible');
	});
});
